import { render, staticRenderFns } from "./DimensionListEditor.vue?vue&type=template&id=47cd9268"
import script from "./DimensionListEditor.vue?vue&type=script&lang=js"
export * from "./DimensionListEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports